import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import SysPw from '../views/sys/SysPw.vue'
import DataDis from '../views/data/DataDis.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
	hidden:true,
	meta:{
	                // 
	        title: '首页'
	    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  	hidden:true
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
	hidden:true,
	meta: {
	    roles: ['admin', 'user']
	},
	children:[
		{
			path:'/sys/syspw',
			name:'修改密码',
			component:SysPw,
			hidden:true
		},
		{
			path:'/data/datadis',
			name:'数据展示',
			component:DataDis,
			hidden:true
		}
	]
  },
   {
      path: '*',
      redirect: '/home'
  }
  //,
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  //mode:"history",
  base:"/vhweb",
  routes
})
// const VueRouterPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push (to) {
//   debugger
//   return VueRouterPush.call(this, to).catch(err => err)
// }

// 捕获push replace中的错误
// 当然在replace中的错误也是可以相同的进行捕获
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {	
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {	
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}


export default router
